import { collection, documentId, getDocs, query, where } from 'firebase/firestore';
import { COLLECTION_TYPES } from './collectionTypes.js';

// Firestore allows at most 10 values in a `documentId() in [...]` filter.
const ID_CHUNK_SIZE = 10;

/**
 * Fetch the published titles for a set of ids.
 *
 * @param {import('firebase/firestore').Firestore} contentDb - content-db client.
 * @param {string[]} titleIds - Candidate material ids. Duplicates are ignored.
 * @returns {Promise<Array<{id: string, docPath: string, [key: string]: any}>>}
 */
export async function fetchPublishedTitles(contentDb, titleIds = []) {
    const ids = [...new Set((titleIds || []).filter(Boolean))];
    if (!contentDb || ids.length === 0) return [];

    const chunks = [];
    for (let i = 0; i < ids.length; i += ID_CHUNK_SIZE) {
        chunks.push(ids.slice(i, i + ID_CHUNK_SIZE));
    }

    const results = await Promise.allSettled(
        chunks.map(async (chunk) => {
            const snap = await getDocs(
                query(
                    collection(contentDb, COLLECTION_TYPES.READ_ONLY_TITLES),
                    where(documentId(), 'in', chunk),
                ),
            );
            return snap.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
                docPath: doc.ref.path,
            }));
        }),
    );

    results
        .filter((r) => r.status === 'rejected')
        .forEach((r) => console.warn('fetchPublishedTitles: chunk failed', r.reason));

    return results
        .filter((r) => r.status === 'fulfilled' && r.value)
        .flatMap((r) => r.value);
}
